import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=8af04ae0&scoped=true"
var script = {}
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=8af04ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af04ae0",
  null
  
)

export default component.exports